import { EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { CommonService } from '../common.service';
var CasePracticeTeamVideoComponent = (function () {
    function CasePracticeTeamVideoComponent(apiService, commonService) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.onGoToQuestion = new EventEmitter();
        this.onGoToBegin = new EventEmitter();
        this.showVideo = true;
        this.assetsRoute = "../../assets";
    }
    CasePracticeTeamVideoComponent.prototype.ngOnInit = function () {
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        var _this = this;
        _this.showVideo = true;
        window['s2j_onPlayOver'] = function () {
            _this.closeVideo();
            _this.apiService.ajax({
                'type': 'post',
                'url': '/sr/onceino/401',
                'data': {}
            }).subscribe(function (result) {
                // _this.onGoToBegin.emit(true);
            });
        };
    };
    CasePracticeTeamVideoComponent.prototype.ngAfterViewInit = function () {
        var player = polyvPlayer({
            wrap: '#video',
            // width: '100vw',
            // height: '100vh',
            width: '100%',
            height: this.isPC ? '100vh' : window.screen.width / 9 * 16,
            vid: '352e2664d84ea777898bd0e732868466_3',
            // autoplay: true,
            // skinLocation: 0,
            ban_history_time: 'on',
            // hideSwitchPlayer: true,
            hideRepeat: true,
            // forceH5: true,
            flashvars: { 'autoplay': true }
            // audioMode: false
        });
        if (!this.isPC) {
            player.toggleFullscreen();
        }
    };
    CasePracticeTeamVideoComponent.prototype.ngOnChanges = function () {
    };
    CasePracticeTeamVideoComponent.prototype.closeVideo = function () {
        var _this = this;
        $("#videoShortCut").show();
        _this.showVideo = false;
        setTimeout(function () {
            if (_this.pageToVideo == 'begin') {
                _this.onGoToBegin.emit(true);
            }
            else {
                _this.onGoToQuestion.emit(true);
            }
        }, 300);
    };
    return CasePracticeTeamVideoComponent;
}());
export { CasePracticeTeamVideoComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-team-video/case-practice-team-video.component.ts.pre-build-optimizer.js